import { fetchApiClient } from '../fetch-api-client';

export const deleteCache = (hash: string, key: string): Promise<void> => {
  return fetchApiClient.delete<void>('/cache', { hash, key });
};
